export default "__VITE_ASSET__Dtd93Oqj__"